module.exports = __webpack_public_path__ + "static/stardust-select-multiple-60c1428b50cf95fca3a027ed92dc7cdf.png";